/* unplugin-vue-components disabled */import { render } from "./RealFaceGuide.vue?vue&type=template&id=638dbb90&scoped=true"
import script from "./RealFaceGuide.vue?vue&type=script&lang=js"
export * from "./RealFaceGuide.vue?vue&type=script&lang=js"

import "./RealFaceGuide.vue?vue&type=style&index=0&id=638dbb90&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638dbb90"]])

export default __exports__